import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from './AuthContext';
import { UserRole } from '@myscaw/shared';

interface RequireRoleProps {
  children: ReactNode;
  allowedRoles: UserRole[];
  fallbackPath?: string;
}

export function RequireRole({
  children,
  allowedRoles,
  fallbackPath = '/dashboard',
}: RequireRoleProps) {
  const { user, loading } = useAuth();
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-pulse text-on-surface-variant">{t('common.loading')}</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // The President has all roles implicitly or explicitly, so always allow if they are PRESIDENT.
  const hasRole = user.roles.some(
    (role) => role === UserRole.PRESIDENT || allowedRoles.includes(role as UserRole),
  );

  if (!hasRole) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
}
